import React, { useEffect, useRef, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import { Button, Table } from "react-bootstrap";
import { useToast } from "../Components/toast/ToastProvider";
import {
  getBillProcessByDate,
  saveBillProcessBulk,
} from "../Service/BillProcessService";
import { getAllVendors } from "../Service/VendorService";
import { getAllVehicles } from "../Service/VehicleService";

const BillProcess = () => {
  const [processDate, setProcessDate] = useState("");
  const [rows, setrows] = useState([]);
  const toast = useToast();
  const [vendors, setVendors] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);

  const normaAdvRef = useRef([]);
  const normalDeRef = useRef([]);
  const resAdvRef = useRef([]);
  const resDeRef = useRef([]);
  const saveBtnRef = useRef([]);

  const handleEnter = (e, type, index) => {
    if (e.key !== "Enter") return;
    e.preventDefault();

    switch (type) {
      case "NOR_ADV":
        normalDeRef.current[index]?.focus();
        break;

      case "NOR_DED":
        resAdvRef.current[index]?.focus();
        break;

      case "RES_ADV":
        resDeRef.current[index]?.focus();
        break;

      case "RES_DED":
        if (index + 1 < rows.length) {
          normaAdvRef.current[index + 1]?.focus();
        } else {
          saveBtnRef.current?.focus();
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    fetchDropdowns();
  }, []);

  const fetchDropdowns = async () => {
    try {
      const [venRes, vehRes] = await Promise.all([
        getAllVendors(),
        getAllVehicles(),
      ]);
      setVendors(venRes?.data || []);
      setVehicles(vehRes?.data || []);
    } catch (err) {
      toast(err.message || "Failed to fetch data", "ERROR");
    }
  };

  const fetchBills = async (date) => {
    if (!date) {
      setrows([]);
      return;
    }

    try {
      const res = await getBillProcessByDate(date);

      const newBills = (res.bills || []).filter((b) => b.status === "new");

      if (newBills.length === 0) {
        setrows([]);
        toast("No bills available for processing", "ERROR");
        return;
      }
      const formatted = newBills.map((b) => {
        const normalList = res.normal_advances.filter(
          (a) => a.vendor_id === b.vendor_id,
        );

        const receiptList = res.receipt_advances.filter(
          (a) => a.vendor_id === b.vendor_id,
        );

        return {
          bill_id: b.bill_id,
          vendor_id: b.vendor_id,
          vehicle_id: b.vehicle_id,
          trip_count: b.trip_count,
          total_amount: b.total_amount,

          normal_advances: normalList,
          nor_advance_id: normalList.length === 1 ? normalList[0].id : null,
          nor_advance: normalList.length === 1 ? normalList[0].amount : 0,
          nor_advance_deduction: b.nor_advance_deduction || 0,

          receipt_advances: receiptList,
          res_advance_id: receiptList.length === 1 ? receiptList[0].id : null,
          res_advance: receiptList.length === 1 ? receiptList[0].amount : 0,
          res_advance_deduction: b.res_advance_deduction || 0,
        };
      });

      setrows(formatted);
    } catch (err) {
      toast(err.message || "Failed to fetch Bill", "ERROR");
    }
  };

  console.log("rows", rows);

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = Number(value);
    setrows(updated);
  };

  const handlesave = async () => {
    if (!rows || rows.length === 0) {
      return;
    }

    const isValidRow = (row) => {
      const total = Number(row.total_amount || 0);
      const norDed = Number(row.nor_advance_deduction || 0);
      const resDed = Number(row.res_advance_deduction || 0);

      const payable = total - (norDed + resDed);

      if (payable < 0) {
        return {
          valid: false,
          msg: "Payable amount cannot be negative",
        };
      }

      return { valid: true };
    };

    for (let r of rows) {
      const check = isValidRow(r);

      if (!check.valid) {
        toast(check.msg, "ERROR");
        return;
      }
    }

    const payload = {
      items: rows.map((r) => ({
        bill_id: r.bill_id,
        nor_advance_deduction: Number(r.nor_advance_deduction || 0),
        nor_advance_id:
          Number(r.nor_advance_deduction || 0) > 0 ? r.nor_advance_id : 0,
        res_advance_deduction: Number(r.res_advance_deduction || 0),
        res_advance_id:
          Number(r.res_advance_deduction || 0) > 0 ? r.res_advance_id : 0,
      })),
    };
    try {
      setLoading(true);
      await saveBillProcessBulk(payload);
      setTimeout(() => {
        toast("Process Saved successfully", "SUCCESS");
      }, 1000);
      setrows([]);
      setProcessDate("");
    } catch (err) {
      toast(err.message || "Save Failed");
    }
  };

  return (
    <Main>
      <PageContainer>
        <CollapseCard title="Bill Process">
          <div style={{ marginBottom: 15 }}>
            <label>Date:</label>
            <input
              type="date"
              value={processDate}
              onChange={(e) => {
                const value = e.target.value;
                setProcessDate(value);
                fetchBills(value);
              }}
            />
          </div>
          {/* 
                    {loading && <p>Loading...</p>} */}

          <Table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vendor</th>
                <th>Trip Count</th>
                <th>Total Amount</th>
                <th>Normal Adv</th>
                <th>Normal Deduction</th>
                <th>Receipt Adv</th>
                <th>Receipt Deduction</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => {
                const vendorName = vendors.find((v) => v.id === r.vendor_id);
                const vehicleNumber = vehicles.find(
                  (ve) => ve.id === r.vehicle_id,
                );
                return (
                  <tr key={r.bill_id}>
                    <td>{i + 1}</td>
                    <td>{vendorName?.name}</td>
                    <td>{r.trip_count}</td>
                    <td>{r.total_amount.toFixed(2)}</td>

                    <td>
                      {r.normal_advances.length <= 1 ? (
                        <input
                          type="text"
                          className="form-control mb-2"
                          value={`Adv: ${Number(r.nor_advance || 0).toFixed(
                            2,
                          )}`}
                          //  || Bal: ${Number(r.nor_remaining_amount || 0).toFixed(2)}
                          readOnly
                          ref={(el) => (normaAdvRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, "NOR_ADV", i)}
                        />
                      ) : (
                        <select
                          value={r.nor_advance_id || ""}
                          onChange={(e) => {
                            const adv = r.normal_advances.find(
                              (a) => a.id == e.target.value,
                            );
                            handleChange(i, "nor_advance_id", adv.id);
                            handleChange(i, "nor_advance", adv.amount);
                          }}
                          ref={(el) => (normaAdvRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, "NOR_ADV", i)}
                          style={{ width: "90px" }}
                        >
                          <option value="">Select</option>
                          {r.normal_advances.map((a) => (
                            <option key={a.id} value={a.id}>
                              Adv: {a.amount.toFixed(2)}
                              {/* || Bal:{a.nor_remaining_amount.toFixed(2)} */}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>

                    <td>
                      <input
                        type="number"
                        min={0}
                        value={r.nor_advance_deduction}
                        disabled={!r.nor_advance || r.nor_advance <= 0}
                        onChange={(e) =>
                          handleChange(
                            i,
                            "nor_advance_deduction",
                            e.target.value,
                          )
                        }
                        ref={(el) => (normalDeRef.current[i] = el)}
                        onKeyDown={(e) => handleEnter(e, "NOR_DED", i)}
                        style={{ width: "90px" }}
                      />
                    </td>

                    <td>
                      {r.receipt_advances.length <= 1 ? (
                        <input
                          type="text"
                          className="form-control mb-2"
                          value={`Adv: ${Number(r.res_advance || 0).toFixed(
                            2,
                          )} `}
                          // || Bal: ${Number(r.res_remaining_amount || 0).toFixed(2)}

                          readOnly
                          ref={(el) => (resAdvRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, "RES_ADV", i)}
                        />
                      ) : (
                        <select
                          value={r.res_advance_id || ""}
                          onChange={(e) => {
                            const adv = r.receipt_advances.find(
                              (a) => a.id == e.target.value,
                            );
                            handleChange(i, "res_advance_id", adv.id);
                            handleChange(i, "res_advance", adv.amount);
                          }}
                          ref={(el) => (resAdvRef.current[i] = el)}
                          onKeyDown={(e) => handleEnter(e, "RES_ADV", i)}
                          style={{ width: "90px" }}
                        >
                          <option value="">Select</option>
                          {r.receipt_advances.map((a) => (
                            <option key={a.id} value={a.id}>
                              Adv: {a.amount.toFixed(2)}
                              {/* || Bal:{a.res_remaining_amount.toFixed(2)} */}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>

                    <td>
                      <input
                        type="number"
                        min={0}
                        value={r.res_advance_deduction}
                        disabled={!r.res_advance || r.res_advance <= 0}
                        onChange={(e) =>
                          handleChange(
                            i,
                            "res_advance_deduction",
                            e.target.value,
                          )
                        }
                        ref={(el) => (resDeRef.current[i] = el)}
                        onKeyDown={(e) => handleEnter(e, "RES_DED", i)}
                        style={{ width: "90px" }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </CollapseCard>

        <div className="d-flex justify-content-end mt-2">
          <Button ref={saveBtnRef} variant="primary" onClick={handlesave}>
            Save
          </Button>
        </div>
      </PageContainer>
    </Main>
  );
};

export default BillProcess;
